import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import theme from './modules/theme'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { user, theme },
  getters: {
    token: state => state.user.token,
    userInfo: state => state.user.userInfo,
    permissions: state => state.user.permissions,
    menus: state => state.user.menus,
    theme: state => state.theme.current,
    themes: state => state.theme.themes
  }
})
